import {Alert} from 'platform/components';

import {isNil} from 'ramda';

import type {MakeOrderStatusIntegration} from '@dms/api/new-vehicle';
import i18n from '@dms/i18n';

type OrderStatusMappingNoteProps = {
  integration: MakeOrderStatusIntegration | null;
};

/** Tells a dealer who maintains the make's order-status mapping, which is read-only for them. */
export function OrderStatusMappingNote(props: OrderStatusMappingNoteProps) {
  return (
    <Alert
      variant="info"
      message={
        isNil(props.integration)
          ? i18n.t('entity.newVehicle.catalogue.noCentralOrderStatusMapping')
          : i18n.t('entity.newVehicle.catalogue.orderStatusMappingManagedCentrally', {
              integration: props.integration.id,
              version: props.integration.version,
            })
      }
    />
  );
}
